<template>
    <div class="h-100 pt-sm-12 pt-md-2">
        <v-row v-if="ready">
            <v-col order-md="last" cols="12" md="4">
               <infoMeter v-if="gateway" :gateway="gateway" :meters="meters" :lastReadings="lastReadings"/>
            </v-col>
            <v-col cols="12" md="8" v-if="gateway">
                <graphs :gateway="gateway" :meters="meters" style="height: 68%"/>
                <simulator class="mt-4" :gateway="gateway" :meters="meters" style="height: 30%"/>
            </v-col>
        </v-row>
        <v-row v-if="ready">
            <v-col cols="12" v-if="gateway">
                <tableReport :meters="meters" :plant="gateway_id"/>
            </v-col>
        </v-row>
        <v-row v-if="!ready" class="text-center align-center h-100">
            <v-col>
                <v-progress-circular
                    width="5"
                    size="50"
                    indeterminate
                    color="accent"
                ></v-progress-circular>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { LINE1, LINE2, LINE3 } from '../components/graphs/props-types'
import { WATTS, AMPS, VOLTS, KWH } from '../components/graphs/props-types'
import { COLUMS, LINES } from '../components/graphs/props-types'
import Chart from '../components/graphs/modules/Chart.js'
import tableReport from '../components/Plants/table'
import { mapGetters, mapState, mapActions } from 'vuex'
import infoMeter from '../components/Plants/info'
import graphs from '../components/Plants/graphs'
import simulator from '../components/Plants/simulator'

export default {
    name: 'Plant',
    components: { infoMeter, graphs, tableReport, simulator },
    computed: {
        ...mapState({
            gateway_id: state => state.gateways.selected,
            gateway(state){
                if(!this.gateway_id) return null
                return state.gateways.list.find(g => g.id === this.gateway_id)
            },
            meters(state){
                if(!this.gateway_id) return null
                return state.meters.list.filter(m => m.gateway === this.gateway_id)
            },
            lastReadings(state){
                if(!this.meters) return null
                if(!state.meters.lastReadings) return null
                let mtrs = this.meters.map( m => m.name )
                return state.meters.lastReadings.filter(r => mtrs.includes(r.meter))
            }
        }),
        ...mapGetters({
            getGateway: 'gateways/getGateway',
            getMeters: 'meters/getMetersGtw'
        })
    },
    data() {
        return {
            Chart,WATTS, AMPS, VOLTS, KWH, COLUMS, 
            LINES,LINE1, LINE2, LINE3,
            ready: true
        };
    },
    methods:{
        ...mapActions({ 
            updatedView: 'user/updatedView'
        }),
        async refresh(){
            this.ready = false
            this.ready = true
        }
    },
    watch:{
        gateway_id(){
            this.refresh()
        },
    },
    mounted(){
        this.updatedView('Plant')
    }
}
</script>

<style scoped>
.h-100{
    height: 100% !important;
}
</style>
